module.exports = __webpack_public_path__ + "static/media/team-main.536b35aa.jpg";